export default {
  common: {
    home: '首页',
    about: '关于',
    search: '搜索',
    loading: '加载中...',
    noData: '暂无数据',
    loadMore: '加载更多',
    backTop: '回到顶部',
    articles: '文章',
    tags: '标签',
    feedback: '反馈',
    all: '全部',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    prev: '上一页',
    next: '下一页',
    page: '第 {n} 页',
    total: '共 {n} 篇',
    sortBy: '排序',
    filterBy: '筛选',
    newest: '最新',
    hottest: '最热',
    notFound: '页面未找到',
    notFoundDesc: '您访问的页面不存在',
    backHome: '返回首页',
    language: '语言',
  },
  nav: {
    nba: 'NBA',
    cba: 'CBA',
    international: '国际篮球',
    equipment: '篮球装备',
    training: '篮球教学',
    culture: '篮球文化',
  },
  news: {
    latest: '最新资讯',
    hot: '热门资讯',
    featured: '精选推荐',
    related: '相关新闻',
    views: '次浏览',
    source: '来源',
    publishTime: '发布时间',
    articleList: '文章列表',
  },
  feedback: {
    title: '意见反馈',
    name: '姓名',
    email: '邮箱',
    message: '反馈内容',
    namePlaceholder: '请输入您的姓名',
    emailPlaceholder: '请输入您的邮箱',
    messagePlaceholder: '请输入您的反馈内容',
    submitSuccess: '感谢您的反馈！',
    submitFail: '提交失败，请稍后重试',
    nameRequired: '请输入姓名',
    emailRequired: '请输入邮箱',
    emailInvalid: '邮箱格式不正确',
    messageRequired: '请输入反馈内容',
  },
  about: {
    title: '关于我们',
    siteName: '网站名称',
    domain: '访问地址',
    category: '领域分类',
    email: '联系邮箱',
    description: '说明',
    descContent: '本站为B530CF站群子站，内容由中枢统一采集审核后自动发布',
  },
  tag: {
    title: '标签云',
    articlesWithTag: '标签下的文章',
  },
  site: {
    name: '篮球世界网',
    slogan: '全球篮球资讯，尽在掌握',
    copyright: '© 2026 篮球世界网 版权所有',
  },
}
